export const isDateValid = (str) => {
    const date = new Date(str);
    return !Number.isNaN(date.getTime());
};
